import { IconBuildingWindTurbine } from "@tabler/icons-react";
import { formatEnergyValue } from "../../../utils/formatEnergyValue";
import { useStartPageProducedElectricity } from "../hooks/useStartPageProducedElectricity";
import type { MiniTileItem } from "./MiniTile";
import { MiniTile } from "./MiniTile";

type ProducedElectricityMiniTileProps = {
  projectId?: string;
  year: number;
};

function ProducedElectricityMiniTile({
  projectId,
  year
}: ProducedElectricityMiniTileProps) {
  const { data, error, isLoading } = useStartPageProducedElectricity(
    year,
    projectId
  );

  const items: Array<MiniTileItem> = [
    {
      label: "Summe seit Jahresbeginn",
      value: data ? formatEnergyValue(data.produced_electricity_kwh ?? 0) : ""
    }
  ];

  return (
    <MiniTile
      error={error}
      icon={<IconBuildingWindTurbine />}
      iconColor="primary"
      isLoading={isLoading}
      items={items}
      title="Erzeugte Strommengen"
    />
  );
}

export { ProducedElectricityMiniTile };
